// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { carouselStyles } from "@eisinc/Overrides/Components/ProductCompareCarousel";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

carouselStyles.xngCarouselStyles = {
    container: {
        css: css`
            .swiper {
                width: 100%;
            }
        `,
    },
};

carouselStyles.productCard = {
    badgesContainerStyle: {
        css: css`
            left: 2px;
        `,
    },
    productGridContainerStyles: {
        container: {
            css: css`
                &&&& {
                    max-width: auto;
                }
                & > .bottom-section {
                    margin-top: 8px;
                }
            `,
        },
    },
};

carouselStyles.carouselCellGridItem = {
    width: 12,
    css: css`
        &&& {
            margin-bottom: 22px;
        }
        .swiper-slide {
            padding-right: 1px;
            > div {
                max-width: 100%;
            }
        }
    `,
};

carouselStyles.attributeCellsGridItem = {
    width: 12,
    css: css``,
};

carouselStyles.attributeContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        &:nth-child(even) {
            background-color: ${color("common.ui2")};
        }
    `,
};

carouselStyles.attributeWrapper = {
    css: css`
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
};

carouselStyles.attributeValue = {
    as: "p",
    size: fontConfig.singleLineSmall.size,
    lineHeight: fontConfig.singleLineSmall.lineHeight,

    css: css`
        padding: 8px;
    `,
};

carouselStyles.attributeValueText = {};

carouselStyles.mainContainer = {
    gap: 0,
    css: css`
        margin: 0 auto;
    `,
    offsetCss: css`
        justify-content: flex-end;
    `,
};

carouselStyles.attributeLabel = {
    ellipsis: true,
    weight: fontConfig.weight.medium,
    size: fontConfig.singleLineRegular.size,
    lineHeight: fontConfig.singleLineRegular.lineHeight,
    css: css`
        padding: 8px;
    `,
};
